import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Layout } from "../components/Navbar";
import { api } from "../api";
import { ServiceBooking } from "../components/ServiceBooking";
import { ShareMenu } from "../components/ShareMenu";
import { SmartBack } from "../components/SmartBack";
import { useSocialMeta } from "../lib/socialMeta";
import { formatProName } from "../lib/proName";

export default function ServiceDetail() {
  const { id } = useParams();
  const { t, i18n } = useTranslation();
  const [s, setS] = useState(null);
  const [err, setErr] = useState(false);
  const [book, setBook] = useState(false);
  useEffect(() => { api.get(`/services/${id}`).then(({ data }) => setS(data)).catch(() => setErr(true)); }, [id]);
  useSocialMeta(s ? {
    title: `${s.name} — ${s.org_name || "YouPAM"}`,
    description: [s.org_name, s.price_cents ? `€ ${(s.price_cents / 100).toFixed(2)}` : t("services.free"), `${s.duration_minutes} min`].filter(Boolean).join(" · "),
    image: null, url: `${window.location.origin}/services/${id}`, type: "article",
  } : null);
  if (err) return <Layout><div className="yp-container py-8"><SmartBack fallbackTo="/search?type=services" label={t("services.title")} /><div className="text-red-600" data-testid="service-error">{t("events.not_available")}</div></div></Layout>;
  if (!s) return <Layout><div className="yp-container py-8" data-testid="service-loading">{t("common.loading")}</div></Layout>;
  const proLabel = s.professional ? (s.professional.free ? s.professional.name : formatProName({ title: s.professional.title, name: s.professional.name }, i18n.language)) : "";
  const loc = [...new Set([s.location_label, s.address].filter(Boolean))].join(" · ");
  return (<Layout><div className="yp-container max-w-3xl py-8" data-testid="service-detail-page">
    <SmartBack fallbackTo={`/organizations/${s.org_id}?tab=services`} label={t("services.title")} />
    <div className="yp-card p-6 yp-gradient-border">
      <div className="flex items-start justify-between gap-3 flex-wrap">
        <h1 className="text-3xl font-bold" data-testid="service-title">{s.name}</h1>
        <ShareMenu shareUrl={`${window.location.origin}/p/servizio-${id}`} title={s.name} />
      </div>
      <Link to={`/organizations/${s.org_id}`} className="inline-block mt-2 text-blue-700 font-medium hover:underline" data-testid="service-org-link">{s.org_name}</Link>
      {proLabel && <Link to={`/professionals/${s.professional?.id || s.professional_id || ""}`} className="block mt-1 text-sm text-slate-600 hover:underline" data-testid="service-pro-link">{proLabel}</Link>}
      {s.description && <p className="mt-3 text-slate-700 whitespace-pre-wrap" data-testid="service-desc">{s.description}</p>}
      <div className="mt-4 grid sm:grid-cols-2 gap-2 text-sm text-slate-600">
        <div data-testid="service-price">💶 {s.price_cents ? `€ ${(s.price_cents / 100).toFixed(2)}` : t("services.free")}</div>
        <div data-testid="service-duration">⏱ {s.duration_minutes} min</div>
        {loc && <div className="sm:col-span-2" data-testid="service-loc">📍 {loc}</div>}
      </div>
      <button className="yp-btn yp-btn-primary mt-5" onClick={() => setBook(true)} data-testid="service-book-btn">{t("services.book_service")}</button>
    </div>
    {book && <ServiceBooking service={{ ...s }} orgId={s.org_id} onClose={() => setBook(false)} />}
  </div></Layout>);
}
